export const AUTH = "auth";
export const LOGIN_USER = "login_user";
export const LOGOUT_USER = "logout_user";
export const LOGIN_FAILED = "login_failed";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";

export const GET_COMPANIES = "get_companies";
export const ACCEPT_COMPANY = "accept_company";
export const SUBMIT_COMPANY = "submit_company";
export const REJECT_COMPANY = "reject_company";

export const SHOW_MODAL = "show_modal";
export const HIDE_MODAL = "hide_modal";



// WEBPACK FOOTER //
// ./src/actions/types.js